export default __webpack_public_path__ + "60a55814b98ed04fdeca7a5c6e7c93b4.png";